/** @jsx jsx */
import React from "react"
import { jsx } from "theme-ui"
import ShowItem from "./show-item"

// ===== Hjälpfunktioner =====
const isTBA = (date) => String(date).toLowerCase() === "tba"

const toTime = (dateStr) => {
  if (!dateStr || isTBA(dateStr)) return NaN
  const parts = String(dateStr).split("-").map(Number)
  if (parts.length !== 3) return NaN
  const [y, m, d] = parts
  if (!y || !m || !d) return NaN
  return Date.UTC(y, m - 1, d)
}

const todayUTC = () => {
  const now = new Date()
  return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
}

// ===== Själva list-komponenten som används i MDX (<Shows />) =====
const Shows = ({ shows = [] }) => {
  const today = todayUTC()

  const tba = []
  const upcoming = []
  const past = []

  // Dela upp shower i TBA, kommande och tidigare
  shows.forEach((s) => {
    const { date } = s

    if (!date || isTBA(date) || Number.isNaN(toTime(date))) {
      tba.push(s)
      return
    }

    const time = toTime(date)

    if (time >= today) {
      upcoming.push(s)
    } else {
      past.push(s)
    }
  })

  // Kommande: närmast först
  upcoming.sort((a, b) => toTime(a.date) - toTime(b.date))

  // Tidigare: senaste först
  past.sort((a, b) => toTime(b.date) - toTime(a.date))

  const [showPast, setShowPast] = React.useState(false)

  return (
    <div>
      {/* Alltid synliga: TBA + kommande */}
      <ul sx={{ listStyle: "none", m: 0, p: 0 }}>
        {[...tba, ...upcoming].map((show) => (
          <ShowItem key={show.id} {...show} />
        ))}
      </ul>

      {/* Collapse-sektion för tidigare gig */}
      {past.length > 0 && (
        <div sx={{ mt: 3 }}>
          <button
            type="button"
            onClick={() => setShowPast((prev) => !prev)}
            sx={{
              background: "none",
              border: "none",
              color: "white",
              fontFamily: "body",
              fontSize: [1, 2],
              p: 0,
              m: 0,
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5em",
              transition: "opacity 0.2s ease, transform 0.2s ease",
              "&:hover": {
                opacity: 0.7,
                transform: "translateX(2px)",
              },
            }}
          >
            <span
              sx={{
                fontSize: "1.4em",
                lineHeight: 1,
                display: "inline-block",
                width: "0.8em",
                textAlign: "center",
              }}
            >
              {showPast ? "−" : "+"}
            </span>

            {showPast ? "Hide past shows" : `Show past shows (${past.length})`}
          </button>

          {showPast && (
            <ul sx={{ listStyle: "none", m: 0, p: 0, mt: 2 }}>
              {past.map((show) => (
                <ShowItem key={show.id} {...show} />
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  )
}

export default Shows
